import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background-color: ${theme.darkGreyBg};
  padding: 30px 0;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0;
  max-width: 1200px;
  margin: 0 auto;
`;

export const QnaSection = styled.div<{ index: number }>`
  padding: 30px;

  ${(props) => `
        &:nth-child(n+3) {
            border-top: 1px solid #979797;
        }
    `}
`;

export const QnaBlockTitle = styled.h2`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 20px;
  color: ${theme.blackText};
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;
export const Question = styled.h3`
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 25px;
  color: ${theme.blackText};

  &::before {
    content: "Q - ";
    color: ${theme.blackText};
  }
`;

export const Answer = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${theme.greyText};

  &::before {
    content: "A: ";
    color: ${theme.greyText};
  }
`;
